import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS, UI, COMPONENT_COLORS } from '../config/colors';
import AIIcon from './AIIcon';

const ChatBubble = ({ message, isAI, isFirstInSequence }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: UI.spacing.medium,
        width: '100%',
        mb: 1.5,
        px: 0,
        position: 'relative',
        marginBottom: '8px',
      }}
    >
      {isAI && (
        <Box sx={{
          width: 20, // Increased from 32 to 40 as per Figma design
          minWidth: 20, // Increased from 32 to 40 as per Figma design
          height: 40, // Increased from 32 to 40 as per Figma design
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '4px',
          // marginRight: '8px'
        }}>
          <AIIcon size={40} /> {/* Increased from 32 to 40 as per Figma design */}
        </Box>
      )}

      <Box
        sx={{
          backgroundColor: isAI
            ? '#FFFFFF'
            : '#F3F4F6', // Changed from purple to light grey
          borderRadius: isAI
            ? '10px 10px 10px 0px'
            : '10px 10px 0px 10px',
          padding: '12px 16px',
          maxWidth: isAI ? '85%' : '50%', // Increased max width for user messages to match components
          width: isAI ? 'auto' : '50%', // Fixed width for user messages to match components
          boxShadow: 'none',
          border: 'none',
          position: 'relative',
          marginLeft: isAI ? '0' : 'auto', // Push user messages to the right
          marginRight: isAI ? '0' : '96px', // Increase from 16px to 32px for more space from the right edge
          alignSelf: isAI ? 'flex-start' : 'flex-end', // Ensure proper alignment
        }}
      >
        <Typography
          sx={{
            color: isAI ? COMPONENT_COLORS.mainContent.primary : '#374151', // Changed from white to dark grey for user messages
            fontFamily: UI.fontFamily.primary,
            fontWeight: UI.fontWeight.regular,
            fontSize: UI.fontSize.medium,
            lineHeight: UI.lineHeight.medium,
            letterSpacing: '0.01em',
            whiteSpace: 'pre-wrap',
            textAlign: isAI ? 'left' : 'right', // Right-align text for user messages
          }}
        >
          {message.replace(/\n/g, '\n')}
        </Typography>
      </Box>
    </Box>
  );
};

export default ChatBubble;
